import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {faPen, faUser} from "@fortawesome/pro-solid-svg-icons";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {TooltipDirective} from '@buildinginformationcloud/bic-ui-components';

/**
 * Upload of Image Component
 */
@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FaIconComponent,
    TooltipDirective
  ]
})
export class ImageUploadComponent implements OnInit {

  /**
   * the image to show as S3 url
   */
  @Input()  image!: string | undefined;
  @Output() imageChange: EventEmitter<any> = new EventEmitter<any>();

  /**
   * Defines if the image should not be editable
   */
  @Input() showOnly: boolean = false;

  @ViewChild('imageInput') imageInputElement!: ElementRef;

  showEdit = false;

  triggerClickOnInput() {
    this.imageInputElement.nativeElement.click();
  }


  /**
   * Initialization of Component
   */
  ngOnInit(): void {
  }

  /**
   * upload method - implement in child class component
   * @param event upload event
   */
  uploadImage(event: any) {
    // Need to be implemented in child class component
  }

  openImageOptions(image: string | undefined){

  }

  protected isDefaultImage(image: string | undefined): boolean {
    const normalizedImage = image?.trim();
    return !normalizedImage
      || normalizedImage === 'null'
      || normalizedImage === 'undefined'
      || normalizedImage.includes('defaultImages/');
  }

  getImage(){
    return this.image;
  }

  setImage(image: string | undefined){
    this.image = image;
    this.imageChange.emit(this.image);
  }

  onImageError(event: Event) {
    console.error('Image failed to load:', this.image, event);
    this.setImage(undefined);
  }


  protected readonly faUser = faUser;
  protected readonly faPen = faPen;
}
